import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import PricingCards from '../landingPage/components/vsl/pricing';
import WhyOrder from '../landingPage/components/vsl/whyOrder';
import Bonuses from '../landingPage/components/vsl/Bonuses';
import Contact from '../landingPage/components/vsl/Contact';
import FAQ from '../landingPage/components/vsl/Faq';
import ClinicalStudies from '../../components/Studies';
import drali from "../../assets/drali.png"
import arrow from "../../assets/blue-arrow.webp"
import Gurantee from './components/gurantee';
import Testimonials from './components/testomonials';
import CommentsList from './components/commentList';
import { comments } from './constant/data';

const V12 = () => {
    const [isShowVsl, setIsShowVsl] = useState(-1);
    const [isVisible, setIsVisible] = useState(false);
    const [isVideoParamExists, setIsVideoParamExists] = useState(null);
    const location = useLocation();
    const pricingRef = useRef(null);
    const [startTimer, setStartTimer] = useState(false);
    const [isVideoPlay, setIsVideoPlay] = useState(false);

    useEffect(() => {
        if (isShowVsl === -1 && location) {
            setIsShowVsl(0);
            const { search } = location;
            const params = new URLSearchParams(search);
            const videoParam = params.get("v");
            setIsVideoParamExists(videoParam === "y");
            setIsShowVsl(1);
        }
    }, [location]);

    useEffect(() => {
        const SECONDS_TO_DISPLAY = 5;
        let attempts = 0;
        let elsDisplayed = false;

        const alreadyDisplayedKey = `alreadyElsDisplayed${SECONDS_TO_DISPLAY}`;
        const alreadyElsDisplayed = localStorage.getItem(alreadyDisplayedKey);

        const showHiddenElements = () => {
            elsDisplayed = true;
            setIsVisible(true);
            localStorage.setItem(alreadyDisplayedKey, true);
        };

        const startWatchVideoProgress = () => {
            if (typeof window.smartplayer === 'undefined' || !(window.smartplayer.instances && window.smartplayer.instances.length)) {
                if (attempts >= 10) return; 
                attempts += 1;
                return setTimeout(() => { startWatchVideoProgress(); }, 1000); 
            }

            const player = window.smartplayer.instances[0];

            player.on('timeupdate', () => {
                if (elsDisplayed || player.smartAutoPlay) return;
                if (player.video.currentTime < SECONDS_TO_DISPLAY) return;
                showHiddenElements(); 
            });

            player.on('play', () => {
                setIsVideoPlay(true);
            });

            player.on('pause', () => {
                setIsVideoPlay(false);
            });
        };

        if (alreadyElsDisplayed === 'true') {
            setTimeout(() => { showHiddenElements(); }, 100); 
        } else {
            startWatchVideoProgress();
        }

    }, []);

    useEffect(() => {
        if (isVisible && pricingRef.current) {
            pricingRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [isVisible]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setIsVisible(true);
            },
            { threshold: 0.1 }
        );

        if (pricingRef.current) observer.observe(pricingRef.current);

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (isVisible && !startTimer) {
            setStartTimer(true);
        }
    }, [isVisible, startTimer]);
    return (
        <>
            {isVideoParamExists !== null && (
                <div className="w-full">
                    {isVideoParamExists ? (
                        <>
                            {/* vsl page */}
                            <div className=''>
                                <div className=" pb-0 text-center flex flex-col items-center justify-center" >

                                </div>
                                <div className={isVideoPlay ? 'w-full' :'max-w-7xl mx-auto'}>
                                    <div className={isVideoPlay ? 'hidden' : " p-3 max-w-7xl text-center flex flex-col items-center justify-center"}>
                                        <h3 className="md:text-2xl text-lg text-black font-bold ">
                                            Top US Respiratory Therapist
                                        </h3>
                                        <p className="lg:text-4xl md:text-3xl sm:text-xl text-base max-w-2xl !text-[#dc252c] font-semibold " style={{ color: "#dc252c", fontWeight: 700, lineHeight: "normalb" }}>
                                            "Do This Daily To Clear Trapped Mucus<br />
                                            & Start Breathing Freely Again!"
                                        </p>
                                    </div>

                                    <div style={{ boxShadow: '0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0), 4px 14px 24px 0px rgba(0, 0, 0, 0.15)' }} className={isVideoPlay ? 'w-full bg-white flex md:flex-row flex-col items-start gap-3' : "w-full bg-white   md:p-10  p-3 flex md:flex-row flex-col items-start gap-3 max-w-4xl mx-auto"}>
                                        <div
                                            className={isVideoPlay ? 'w-full' : "md:w-3/4 w-full"}
                                            dangerouslySetInnerHTML={{
                                                __html: `<script type="text/javascript" id="scr_677d54bf4e05c0518227c3d5"></script>`,
                                            }}

                                        />

                                        {/* Helmet to inject the video player script into the head */}
                                        <Helmet>
                                            <script type="text/javascript">
                                                {`
          var s = document.createElement("script");
          s.src = "https://scripts.converteai.net/10a8aace-0f8a-44a8-a764-4b0ebbd85e70/players/677d54bf4e05c0518227c3d5/player.js";
          s.async = true;
          document.head.appendChild(s);
        `}
                                            </script>
                                        </Helmet>

                                        <div className={isVideoPlay ? 'hidden' : "md:block hidden w-1/4"}>
                                            <div className=' flex items-center justify-center flex-col  space-y-2 '>
                                                <img src={drali} alt='Dr.ali' className='rounded-full w-28 h-28 object-cover' />

                                                <p className=' rounded-md text-white px-1  bg-[#E34134] font-bold text-base w-fit'>
                                                    Top Pulmonologist
                                                </p>
                                                <h2 className='text-2xl px-6 font-black text-center underline text-[#132c4d]'>
                                                    Dr.Ali, M.D
                                                </h2>
                                                <div>
                                                    <p className='font-normal text-center text-xs '>
                                                        Dr. Ali is a highly respected pulmonologist and sinus health expert. Last year, U.S. News & World Report recognized him as one of the top pulmonologists in Georgia and the Southern United States.
                                                    </p>
                                                </div>
                                                {/* <img src={ElizabethSignature} alt='ElizabethSignature' /> */}

                                            </div>
                                        </div>

                                    </div>

                                    <div id="smartplayer" style={{
                                        width: '100%',
                                        position: 'relative',
                                        padding: '0',
                                    }}></div>

                                    <div className=" pt-10 p-3 max-w-7xl space-y-3 text-center flex flex-col items-center justify-center" >
                                        <h3 className="md:text-lg text-sm max-w-3xl text-gray-700 font-semibold ">
                                            <strong className='text-red-600'>
                                                IMPORTANT:
                                            </strong>Your video may take 10 seconds to load. Make sure your sound is on.
                                        </h3>
                                        <img src={arrow} />
                                    </div>
                                </div>


                            </div>
                            {isVisible &&
                                <div className="hide smartplayer-scroll-event" id="hidden-section">
                                    <div ref={pricingRef}>
                                        <PricingCards startTimer={startTimer} />
                                    </div>
                                    <WhyOrder />
                                    <Gurantee />
                                    <Bonuses />
                                    <Contact />
                                    <Testimonials />
                                    <PricingCards startTimer={startTimer} />
                                    <FAQ />
                                    <CommentsList comments={comments} />
                                </div>
                            }
                            {/* <TherapistInfo /> */}
                            <ClinicalStudies />
                        </>
                    ) : (
                        <div className="min-h-screen bg-navy-900">
                            <PricingCards startTimer={startTimer} />
                            <WhyOrder />
                            <Gurantee />
                            <Bonuses />
                            <Contact />
                            <Testimonials />
                            <PricingCards startTimer={startTimer} />
                            <FAQ />
                            <CommentsList comments={comments} />

                        </div>
                    )}
                </div>
            )}
        </>
    )
}

export default V12
